import { FieldValidation } from '@rjsf/utils';

import { DaasComponentPickerConfig } from './types';

export const daasComponentPickerValidation = (
  value: DaasComponentPickerConfig,
  validation: FieldValidation,
): void => {
  if (!value) {
    validation.addError('Please select a DaaS Component');
    return;
  }
  if (!value.type) {
    validation.addError('Please select a DaaS Component type');
    return;
  }
  if (!value.entityRef) {
    validation.addError('Please select a DaaS Component');
    return;
  }

  if (value.relationsValidation) {
    if (value.dependencyOf && value.dependencyOf.length !== 0) {
      validation.addError(
        `The selected component has existing dependencies: ${value.dependencyOf?.join(
          ', ',
        )}. Please delete them before proceeding.`,
      );
      return;
    }
  }
};
